import { PortalIcon, type PortalIconProps } from './portal-icon';

/** Location pin — pickup shop address. */
export function LocationPinIcon(props: PortalIconProps) {
  return (
    <PortalIcon {...props}>
      <path d="M12 21s-6.5-5.6-6.5-10.4a6.5 6.5 0 0 1 13 0C18.5 15.4 12 21 12 21Z" />
      <circle cx="12" cy="10.4" r="2.3" />
    </PortalIcon>
  );
}
